
import {PRAVESH_API, NIYUKTI_API} from  "../utility/constant";

export const BASE_URL = PRAVESH_API;
export const BASE_URL_2 = NIYUKTI_API;